import { Banner, Button, Link, Tag } from '@dev-spendesk/grapes';
import classNames from 'classnames';

import { useModal } from 'src/core/common/hooks/useModalGrapes';
import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { ApprovalByDimensionsActivationModal } from './ApprovalByDimensionsActivationModal';
import { ReactComponent as BannerIllustration } from './bannerIllustration.svg';
import { useMigrateToApprovalWorkflow } from '../hooks/useMigrateToApprovalWorkflow';

type Props = {
  className?: string;
};

export const ApprovalByDimensionsActivationBanner = ({ className }: Props) => {
  const { t } = useTranslation('global');

  const { mutate: migrateToApprovalWorkflow } = useMigrateToApprovalWorkflow();

  const [migrationModal, showMigrationModal] = useModal(
    ({ isOpen, onClose }) => (
      <ApprovalByDimensionsActivationModal isOpen={isOpen} onClose={onClose} />
    ),
  );

  const handleMigrationClick = () => {
    showMigrationModal();
    migrateToApprovalWorkflow();
  };

  return (
    <>
      {migrationModal}
      <Banner
        illustration={<BannerIllustration className="w-[80px] shrink-0" />}
        variant="brand"
        title=""
        className={classNames('text-left', className)}
        actions={
          <Button
            variant="secondaryNeutral"
            text={t('costCenters.activationBanner.actionText')}
            onClick={() => handleMigrationClick()}
          />
        }
      >
        <div>
          <div className="-mt-8 mb-8 flex items-center gap-8 text-content-primary title-xl">
            {t('costCenters.activationBanner.title')}
            <Tag variant="purple">{t('misc.new')}</Tag>
          </div>
          {t('costCenters.activationBanner.description')}{' '}
          <Link
            href="https://helpcenter.spendesk.com/articles/10539598-approval-workflows#h_1dfd5d7510"
            target="_blank"
          >
            {t('costCenters.activationBanner.learnMore')}
          </Link>
        </div>
      </Banner>
    </>
  );
};
